import { createObjectUrlFromBlob, revokeObjectUrl } from '../windowUtils';
export function downloadFile(fileName, type, data) {
    const url = createObjectUrlFromBlob(data, { pdf: 'application/pdf', ofx: 'application/x-ofx' }[type]);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.${type}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    revokeObjectUrl(url);
}
export function downloadBase64AsPDF(base64Data, filename) {
    const cleanBase64 = base64Data.replace(/^data:application\/pdf;base64,/, '');
    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    downloadFile(filename, 'pdf', [byteArray]);
}
export function openBase64PdfInNewTab(base64Data) {
    const cleanBase64 = base64Data.replace(/^data:application\/pdf;base64,/, '');
    const byteCharacters = atob(cleanBase64);
    const byteArray = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));
    const blobUrl = createObjectUrlFromBlob([byteArray], 'application/pdf');
    window.open(blobUrl, '_blank');
}
